export var WidgetsEnum;
(function (WidgetsEnum) {
    WidgetsEnum["TOP_SELLING_WIDGET"] = "TOP_SELLING_WIDGET";
    WidgetsEnum["REWARDS_AVAILABLE_WIDGET"] = "REWARDS_AVAILABLE_WIDGET";
    WidgetsEnum["REWARDS_TO_EARN_WIDGET"] = "REWARDS_TO_EARN_WIDGET";
    WidgetsEnum["PROMOTIONS_WIDGET"] = "PROMOTIONS_WIDGET";
})(WidgetsEnum || (WidgetsEnum = {}));
//# sourceMappingURL=web-merchant-app-widgets.enum.js.map